import axios from 'axios';
import { getAllObservationsQuery } from './GQLQueries';

const getAllObservations = async (
  graphQlHubServiceUrl,
  username,
  cancelToken = undefined
) => {
  // todo: update the way errors are handled just like the methods below.
  const response = await axios.post(
    graphQlHubServiceUrl,
    {
      query: getAllObservationsQuery,
      variables: { username: username }
    },
    Object.assign(
      {},
      {
        cancelToken: cancelToken
      }
    )
  );

  return response.data.data.observations;
};

export { getAllObservations };



// WEBPACK FOOTER //
// ./src/apis/ObservationApi.js